import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem("opl_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && localStorage.getItem("opl_token") && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("opl_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function fmtL(v, digits = 2) {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  return `${n.toLocaleString("en-IN", { maximumFractionDigits: digits })}\u202Fpts`;
}

export const fileUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${BACKEND}${p}`);

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function blobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const ROLES = ["Batsman", "Bowler", "All-Rounder", "Wicketkeeper-Batsman"];
export const ROLE_LABEL = { super_admin: "Super Admin", auction_admin: "Auction Admin", auctioneer: "Auctioneer", team_owner: "Team Owner", viewer: "Viewer" };
